import { Box, Skeleton } from '@mui/material'
import { ChevronsUpDown } from 'lucide-react'
import { useOrgBilling } from 'settings/billing/hooks/useOrgBilling'
import { useChangeOrg } from '../hooks/useChangeOrg'
import { useOrgName } from '../hooks/useOrgName'
import { useOrgs } from '../hooks/useOrgs'
import { Avatar } from './Avatar'
import { Chip } from './Chip'
import { useCreateOrgDialog } from './CreateNewOrgDialog'
import { Link } from './Link'
import { Select } from './Select'
import { isFreeSubscription } from 'settings/billing/utils/enrichSubscriptionUtils'

export const OrgsDropdown = ({
  showFreeTag = true,
  showSelectedOrg = true,
  allowAddNew = true,
  selectProps = {
    type: 'menu',
  },
  sx = {},
}) => {
  const { changeOrg } = useChangeOrg()
  const orgName = useOrgName()

  const link = `/${orgName}/apps`
  const { openDialog, closeDialog } = useCreateOrgDialog()
  const { subscription, isLoading } = useOrgBilling()
  /**
   * Fetch my orgs
   */
  const { orgs, isLoadingOrgs } = useOrgs()

  if (!orgName || isLoadingOrgs) {
    return <Skeleton variant="rect" width="160px" height="28px" />
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ...(sx || {}),
      }}
    >
      {
        /**
         * If select type is menu then here we want to show the current selected org because dropdown will be a an icon
         */
        showSelectedOrg && (
          <Link to={link} underline="hover">
            {orgName}
          </Link>
        )
      }
      {isFreeSubscription(subscription) && !isLoading && showFreeTag && (
        <Chip
          label="Free"
          size="small"
          to={`/${orgName}/settings/billing`}
          sx={{
            marginLeft: '10px',
            backgroundColor: 'grey.dark',
          }}
        />
      )}

      <Select
        type={selectProps?.type}
        icon={<ChevronsUpDown size={14} />}
        allowFilter
        onAddNewClick={allowAddNew && openDialog}
        menuProps={{
          sx: {
            '& .MuiPaper-root': {
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            },
          },
        }}
        buttonProps={{
          size: 'tiny',
          color: 'secondary',
        }}
        options={[
          ...orgs?.map((org) => ({
            label: org?.orgName,
            value: org?.orgName,
            icon: (
              <Avatar
                disableHover={true}
                avatarProps={{
                  size: 20,
                }}
              />
            ),
          })),
        ]}
        onChange={(newOption) => {
          closeDialog()
          changeOrg(newOption?.value)
        }}
        {...selectProps}
      />
    </Box>
  )
}
